import "./confirm-delete.modal.scss";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import TRASH_RED from "../assets/images/trash-red.png";
const ConfirmDeleteModal = ({ isOpen, onClose, onDelete, message, message2, buttonCancel, buttonConfirm }) => {

    const handleClose = () => {
        onClose(false);
    }

    const handleConfirm = () => {
        onDelete();
    }

    return (
        <Modal centered show={isOpen} onHide={onClose} className="confirm-delete-control">
            <Modal.Body className="confirm-delete-body">
                <FontAwesomeIcon icon={faClose} className="confirm-delete-icon-close" onClick={handleClose}></FontAwesomeIcon>

                <img src={TRASH_RED} className="confirm-delete-icon-trash"></img>

                <p className="confirm-delete-title">
                    {message}
                </p>

                <p className="confirm-delete-description">
                   {message2}
                </p>

                <div className="confirm-delete-action">
                    <Button
                        className="cancel-delete-button"
                        onClick={handleClose}
                    >
                        {buttonCancel}
                    </Button>

                    <Button
                        className="confirm-delete-button"
                        onClick={handleConfirm}
                    >
                        {buttonConfirm}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ConfirmDeleteModal;